import { render, staticRenderFns } from "./restaurant_info.vue?vue&type=template&id=522a6842&scoped=true&"
import script from "./restaurant_info.vue?vue&type=script&lang=js&"
export * from "./restaurant_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522a6842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522a6842')) {
      api.createRecord('522a6842', component.options)
    } else {
      api.reload('522a6842', component.options)
    }
    module.hot.accept("./restaurant_info.vue?vue&type=template&id=522a6842&scoped=true&", function () {
      api.rerender('522a6842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/restaurant_info.vue"
export default component.exports